import { Row } from 'antd'
import LineItemScheduler from 'app/components/Core/LineItem/Scheduler/Scheduler'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useIndex } from 'app/lib/hooks/useQuery'
import { RecordTypeEnum } from 'app/queries'
import * as React from 'react'
import { useIntl } from 'react-intl'

import StatusFilter from './ProjectPlanFilters'

type Props = {
  project: IProject
}

const ProjectPlan: React.FC<Props> = ({ project }) => {
  const { formatMessage } = useIntl()
  const [filterStatus, setFilterStatus] = React.useState<IFilterStatus>(null)
  const { loading, data } = useIndex<ILineItem>(RecordTypeEnum.lineItem, {
    variables: {
      lineItemType: 'product',
      projectId: project?.id
    }
  })

  const collection = data?.nodes || []

  return (
    <Row gutter={[12, 12]}>
      <KCol
        title={formatMessage({ id: 'project.scheduler.header' })}
        card
        span={24}
        loading={loading}>
        <LineItemScheduler
          collection={collection}
          props={{
            filters: <StatusFilter value={filterStatus} onChange={setFilterStatus} />
          }}
        />
      </KCol>
    </Row>
  )
}

export default ProjectPlan
